export default __webpack_public_path__ + "static/media/rem-but.f9a1f1d8.svg";